import React from 'react';

export default function LogDetail(props) {
  return (
    <ul className="log-list">
      {
        props.store.logs.map((item, index) => (
          <li
            key={item.log_serial_number + index}
            className={['log-list-item', item.postState === 'fail' ? 'error' : ''].join(' ')}
          >
            <span>{item.log_time.substr(11)}</span>&nbsp;&nbsp;
            <span style={item.log_content.indexOf('安装调试失败') !== -1 ? { color: 'red' } : {}}>{item.log_content}</span>
          </li>
        ))
      }
    </ul>
  );
}
